module.exports = __webpack_public_path__ + "img/shadow.b85b3e98.jpg";